export enum DateOptions {
  TODAY = "TODAY",
  EIGHT_DAYS_AGO = "EIGHT_DAYS_AGO",
}
